export default __webpack_public_path__ + "static/media/coloured-card-with-btn.4ca23e71.jpg";